import { render, staticRenderFns } from "./ProvinceSeperatedPanel.vue?vue&type=template&id=71da6189"
import script from "./ProvinceSeperatedPanel.vue?vue&type=script&lang=js"
export * from "./ProvinceSeperatedPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports